import ColorThemeAwareDiagram from './color-theme-aware-diagram.js'

export default class YearlyActivity extends ColorThemeAwareDiagram {
  constructor() {
    super();

    this.xAxisSelector   = this.dataset.xAxisSelector   || '.season';
    this.yAxisSelector   = this.dataset.yAxisSelector   || '.species';
    this.zAxisSelector   = this.dataset.zAxisSelector   || '.quantity';
    this.datasetSelector = this.dataset.datasetSelector || '.dataset';

    this.chartOptions = {
      scales: {
        y: {
          type: 'linear',
          position: 'left',
          beginAtZero: true,
          title: {
            display: true,
            text: window.I18n.t('js.chart.activity'),
            color: _ => this.textColor,
            font: _ => this.fontFamily
          },
          grid: {
            color: 'rgba(120,120,120,0.2)',
            drawTicks: true
          },
          ticks: {
            color: _ => this.textColor,
            width: 1,
            min: 0
          }
        }
      },
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          labels: {
            color: _ => this.textColor
          }
        }
      }
    }
  }

  connect() {
    if (this.canvas) {
      if (this.chart) {
        this.chart.destroy();
      }

      let chartLabels = [];
      let seasonNames = [];
      let colors     = [];
      let speciesRawData = {};
      let chartData = {
        labels:   [],
        datasets: []
      };

      window.setTimeout(_ => {
        this.querySelectorAll(this.xAxisSelector).forEach((seasonElem) => {
          let xAxisName = seasonElem.dataset.value;
          seasonNames.push(xAxisName);
        });

        this.querySelectorAll(this.datasetSelector).forEach((elem, idx) => {
          let speciesName = elem.querySelector(this.yAxisSelector).innerText.replace(/^\s+|\s+$/g, '');

          colors[speciesName] = elem.dataset.graphColour;
          seasonNames.forEach((xAxisName) => {
            let observationQuantity = parseInt(elem.querySelector(`[data-season='${xAxisName}']`).innerText);

            if (!speciesRawData[speciesName]) {
              speciesRawData[speciesName] = {};
            }

            if (!speciesRawData[speciesName][xAxisName]) {
              speciesRawData[speciesName][xAxisName] = 0;
            }

            if (observationQuantity > 0) {
              speciesRawData[speciesName][xAxisName] += observationQuantity;
            }
          });
        });

        seasonNames = this.unique(seasonNames.sort());

        Object.keys(speciesRawData).forEach((speciesName) => {
          let colour = colors[speciesName];

          let speciesDatum = {
            backgroundColor:      `rgba(${colour},0.4)`,
            borderColor:          `rgba(${colour},0.7)`,
            hoverBackgroundColor: `rgba(${colour},0.9)`,
            hoverBorderColor:     `rgba(${colour},1.0)`,
            label:                 speciesName,
            type:                 'line',
            // multiTooltipTemplate: '<%=value%> <%=datasetLabel%>',
            data:                 []
          };
          chartData.datasets.push(speciesDatum);

          seasonNames.forEach((seasonName, idx) => {
            chartData.labels[idx] = seasonName;

            speciesDatum.data[idx] = speciesRawData[speciesName][seasonName] || 0;
            speciesDatum.borderWidth = 2;
            speciesDatum.pointRadius = 2;
          });
        });

        this.buildChart('bar', chartData, this.chartOptions);
      });
    } else {
      console.error('no <canvas> element found within <yearly-activity>!');
    }
  }

  unique(array) {
    return array.filter((el, index, arr) => {
      return index === arr.indexOf(el);
    });
  }
}
